import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getFaqs } from 'store/faq';
import AnimatedTabs from 'components/ui/AnimatedTabs';
import { useNavigate } from 'react-router-dom';

const Faq = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { list } = useSelector(state => state.faq);
  const { language } = useSelector((state) => state.app);

  const [loading, setLoading] = useState(true);

  const fetchList = () => {
    dispatch(getFaqs())
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchList();
  }, [])

  if (loading || !list) {
    return (
      <div className="px-8 grid grid-cols-1 gap-5 overflow-y-scroll pb-6 animate-pulse pt-20">
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
      </div>
    );
  }

  return (
    list &&
    <div className="h-full w-full px-8 pb-1 pt-20 flex flex-col gap-12">
      <div className="flex justify-center">
        <img
          alt="library"
          src="library-logo.svg"
        />
      </div>
      <div className="flex flex-col justify-center items-center gap-1">
        <div className="flex items-center gap-1">
          <span className="text-sm font-light text-[#808080]">
            {t('footer.powered')}
          </span>
          <span className="text-sm font-semibold">
            Lokk
          </span>
        </div>
        <span className="text-sm text-[#808080]">
          Version 1.0
        </span>
      </div>
      <div className="h-full w-full">
        <AnimatedTabs tabs={list.map((item) => ({ title: item.title[language], content: item.text[language] }))} />
      </div>
      <div className="flex justify-center">
        <span className="underline" onClick={() => navigate('/terms')}>
          {t('terms.label')}
        </span>
      </div>
    </div>
  )
}

export default Faq;